import { TournamentHostSocketType } from "@soposopo/sopo-models/dist";
import { Observable, Subscription } from "rxjs";
import { GameServer } from "./game-server.class";
import { DEFAULT_DISMISS_AFTER_TIME } from "src/app/sopo-popup/service/sopo-popup.service";

export abstract class TournamentGameServer extends GameServer {
    
    private tournamentMessageSubscription: Subscription;
    private tournamentErrorSubscription: Subscription;
    private tournamentSubscription: Subscription;
    private tournamentDelearErrorSubscription: Subscription;

    constructor () {
        super();
    }

    protected injectServices () {
        super.injectServices();
    }

    listenToMessages() {
        super.listenToMessages();
        this.tournamentMessageSubscription = this.getTournamentMessage().subscribe((data) => {
            let header = '';
            let message = '';

            if (data.socketType &&
                (
                data.socketType === TournamentHostSocketType.ComeBackError ||
                data.socketType === TournamentHostSocketType.AddonFailed
                )
            ) {
                this.getHeaderAndShowAlert(data) 
            }

            if (header != '' || message != '') {
                this.showAlertMessage(header, message);
            }
            this.gameSocketsDispatcher.acceptTableSignal(data);
        });

        this.tournamentErrorSubscription = this.getTournamentError().subscribe((data) => {
            this.showTournamentError(data);
            this.gameSocketsDispatcher.acceptTableSignal(data);
        });
    }

    private async showTournamentError(data: any) {
        this.loadingCtrl.dismiss('tournament');
        await this.getAlertMessage(data);
    }

    protected async getHeaderAndShowAlert(data) {
        let alertHeader = '';
        alertHeader = 'Error';
        this.showAlertMessage(alertHeader, data.message); 
    }

    private async showAlertMessage(header: string, message: string) {
        this.loadingCtrl.dismiss('tournament');
        this.loadingCtrl.dismiss('restricted');
        this.sopoPopupService.showAlert(
            'game',
            {
                header,
                message,
                dismissAfter: DEFAULT_DISMISS_AFTER_TIME,
            },
        );
    }

    getTournamentMessage(): Observable<any> {
        return this.socket.fromEvent('tournamentMessage');
    }

    private getTournamentError(): Observable<any> {
        return this.socket.fromEvent('tournamentError');
    }

    protected stopListeningToMessages() {
        super.stopListeningToMessages();
        if (this.tournamentMessageSubscription) {
            this.tournamentMessageSubscription.unsubscribe();
        }
        if (this.tournamentSubscription) {
            this.tournamentSubscription.unsubscribe();
        }
        if (this.tournamentErrorSubscription) {
            this.tournamentErrorSubscription.unsubscribe();
        }
        if (this.tournamentDelearErrorSubscription) {
            this.tournamentDelearErrorSubscription.unsubscribe();
        }
    }
}
